/**
 * Badge visual para la propuesta IA de un pago de tasa.
 * Estados: SE_PUEDE_RECLAMAR | POSIBLE_NO_RECUPERABLE | PENDIENTE_RESOLUCION | NO_APLICA | REVISAR_MANUAL
 * Props:
 *   - estado:    código del estado IA
 *   - confianza: 0..1
 *   - revisado:  true si el usuario ya lo revisó/corrigió → marca visual "✓ revisado"
 *   - onClick:   abrir modal
 *   - compact:   solo icono
 */
import React from 'react';
import { CheckCircle2, XCircle, Clock3, HelpCircle, AlertTriangle, Sparkles, ShieldCheck } from 'lucide-react';

const STYLES = {
  SE_PUEDE_RECLAMAR:      { cls: 'bg-emerald-100 text-emerald-800 border-emerald-300', icon: CheckCircle2, label: 'Se puede reclamar' },
  POSIBLE_NO_RECUPERABLE: { cls: 'bg-rose-100 text-rose-800 border-rose-300',          icon: XCircle,      label: 'No recuperable' },
  PENDIENTE_RESOLUCION:   { cls: 'bg-amber-100 text-amber-800 border-amber-300',       icon: Clock3,       label: 'Pendiente resolución' },
  NO_APLICA:              { cls: 'bg-gray-100 text-gray-700 border-gray-300',          icon: HelpCircle,   label: 'No aplica' },
  REVISAR_MANUAL:         { cls: 'bg-indigo-100 text-indigo-800 border-indigo-300',    icon: AlertTriangle,label: 'Revisar manual' },
};

export const AnalisisIATasasBadge = ({ estado, confianza, onClick, compact = false, revisado = false }) => {
  if (!estado) {
    return (
      <span className="inline-flex items-center gap-1 text-xs text-gray-400 italic" data-testid="ia-badge-empty">
        <Sparkles className="w-3 h-3" /> sin analizar
      </span>
    );
  }
  const cfg = STYLES[estado] || STYLES.REVISAR_MANUAL;
  const Icon = cfg.icon;
  const pct = confianza != null ? ` · ${Math.round(confianza * 100)}%` : '';
  // Si el usuario ya lo revisó, añadimos borde doble + icono de verificación humana.
  const revisadoCls = revisado ? ' ring-2 ring-offset-1 ring-green-500' : '';
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={`ia-badge-${estado}${revisado ? '-revisado' : ''}`}
      className={`inline-flex items-center gap-1 px-2 py-0.5 text-xs font-semibold rounded-full border hover:brightness-95 transition cursor-pointer ${cfg.cls}${revisadoCls}`}
      title={revisado
        ? 'Revisado por el usuario · click para ver detalles'
        : 'Propuesta IA · click para ver el razonamiento o corregir'}
    >
      <Icon className="w-3 h-3" />
      {compact ? '' : cfg.label}
      <span className="opacity-70">{pct}</span>
      {revisado && (
        <ShieldCheck className="w-3 h-3 text-green-700" aria-label="Revisado por el usuario" />
      )}
    </button>
  );
};

export default AnalisisIATasasBadge;
